import { Typography } from "@connected-repo/ui-mui/data-display/Typography";
import { Button } from "@connected-repo/ui-mui/form/Button";
import { Box } from "@connected-repo/ui-mui/layout/Box";
import { useNavigate, useRouteError } from "react-router";

export const RouteErrorPage = () => {
	const error = useRouteError() as { message?: string } | undefined;
	const navigate = useNavigate();
	return (
		<Box sx={{ p: 6, textAlign: "center" }}>
			<Typography variant="h5" sx={{ fontWeight: 700, mb: 1 }}>
				Something went wrong
			</Typography>
			<Typography color="text.secondary" sx={{ mb: 3 }}>
				{error?.message ?? "Unknown error"}
			</Typography>
			<Button variant="contained" onClick={() => navigate("/teams")}>
				Back to teams
			</Button>
		</Box>
	);
};
